import { avl } from './avlTreeReducer'

export default { avl }
